"use strict";

exports.__esModule = true;

var Metrics =
/** @class */
function () {
  function Metrics(defaultCategory, appenders) {
    this.defaultCategory = defaultCategory;
    this.appenders = appenders;
    this.sendedEvents = {};
  }

  Metrics.prototype.trackEvent = function (category, action, label, value) {
    this.append(category, action, label, value);
  };

  Metrics.prototype.trackEventSingle = function (category, action, label, value) {
    var key = category + action + label || '';

    if (this.sendedEvents[key]) {
      return;
    }

    this.trackEvent(category, action, label, value);
    this.sendedEvents[key] = true;
  };

  Metrics.prototype.trackEventNC = function (action, label, value) {
    if (this.defaultCategory) {
      this.trackEvent(this.defaultCategory, action, label, value);
    }
  };

  Metrics.prototype.trackEventNCSingle = function (action, label, value) {
    if (this.defaultCategory) {
      this.trackEventSingle(this.defaultCategory, action, label, value);
    }
  };

  Metrics.prototype.append = function (category, action, label, value) {
    try {
      this.appenders.forEach(function (appender) {
        var event = new MetricsEvent(category, action, label, value);
        appender.append(event);
      });
      return this;
    } catch (e) {
      return this;
    }
  };

  return Metrics;
}();

exports.Metrics = Metrics;
var defaultAppenders = [];

var MetricsManager =
/** @class */
function () {
  function MetricsManager() {}

  MetricsManager.getMetrics = function (defaultCategory) {
    return new Metrics(defaultCategory, defaultAppenders);
  };

  MetricsManager.addAppender = function (appender) {
    defaultAppenders.push(appender);
  };

  return MetricsManager;
}();

exports.MetricsManager = MetricsManager;

var MetricsEvent =
/** @class */
function () {
  function MetricsEvent(category, action, label, value) {
    this.category = category;
    this.action = action;
    this.label = label;
    this.value = value;
  }

  return MetricsEvent;
}();

exports.MetricsEvent = MetricsEvent;
exports.LOG_PREFIX = 'mtx_';